import { Component, NgZone, OnInit } from '@angular/core';
import { Breadcrumb, GenerateTableColumn, GenerateTablePageEvent, GenerateTablePagination } from '../../shared/components';
import { GenericRelatorioComponent } from 'src/app/relatorio/generic-relatorio.component';
import { BeneficiariaService } from 'src/app/beneficiaria/beneficiaria.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Beneficiaria } from 'src/app/beneficiaria/beneficiaria.model';
import { catchErr } from 'src/app/shared/utils';
import { NgForm } from '@angular/forms';
import { U } from '@angular/cdk/unique-selection-dispatcher.d-DSFqf1MM';
import { UsuarioResponse, UsuarioService } from 'src/app/usuario';
import { AprovacoesMarcelinhoService } from './aprovacoes-marcelinho.service';
import dayjs from 'dayjs';
import { catchError, concat, distinctUntilChanged, map, Observable, of, Subject, switchMap, tap } from 'rxjs';
import { Pagination } from 'src/app/shared/models/pagination.model';

@Component({
    selector: 'app-aprovacoes-marcelinho',
    templateUrl: './aprovacoes-marcelinho.component.html',
    styleUrls: ['./aprovacoes-marcelinho.component.css'],
    standalone: false
})
export class AprovacoesMarcelinhoComponent extends GenericRelatorioComponent implements OnInit {

    breadcrumb: Breadcrumb[] = [
        { label: 'Início' },
        { label: 'Configurações' },
        { label: 'Aprovações' },
    ];

    usuario$: Observable<UsuarioResponse[]>;
    usuarioInput$ = new Subject<string>();
    user?: any;
    progressValue: number = 0;
    progressInterval: any;

    dataSource: any[];
    emailUsuario: string;
    pagination: GenerateTablePagination = { total: 0, current: 0, pageSize: 10 };
    columns: GenerateTableColumn[] = [
        { header: '#', attr: 'index' },
        { header: 'DIO', attr: 'numeroDio' },
        { header: 'Prefixo', attr: 'prefixo' },
        { header: 'Contrato', attr: 'contrato' },            
        { header: 'Equipamento', attr: 'placa' },
        { header: 'Início Operação', attr: 'dataInicioOperacao' },   
        { header: 'Condutor', attr: 'condutor' },   
        { header: 'Status Execução', attr: 'statusExecucao' },      
    ];

    constructor(
        private ngZone: NgZone,
        private usuarioService: UsuarioService,
        protected override beneficiariaService: BeneficiariaService,
        private aprovacaoMassivaService: AprovacoesMarcelinhoService,
        protected override snackBar: MatSnackBar,
    ) {   
        super(beneficiariaService, snackBar);
    }

    ngOnInit(): void {        
        this.getUsuarios();
    }

    setBeneficiaria(beneficiaria: Beneficiaria) {
        console.log('Beneficiária selecionada:', beneficiaria);
        this.filters.beneficiaria = beneficiaria;
        this.filters.contrato = undefined;

        this.beneficiariaService.getContratos(beneficiaria.id!).subscribe({
            next: (res) => this.contratos = res,
            error: (err) => catchErr(err, this.snackBar)
        }).add(() => this.loading = false);
    }

    async save(form: NgForm){
        console.log('user: ', this.user);
        this.loading = true;
        this.progressValue = 0;

        // Iniciar progresso simulado: incrementa 10% a cada 3 segundos
        this.progressInterval = setInterval(() => {
            this.ngZone.run(() => {
                if (this.progressValue < 90) {
                    this.progressValue += 10;
                }
            });
        }, 1000);

        const aprovacaoMassiva = {
            role: this.filters.perfilUsuario!,
            dataInicio: this.filters.dataInicio ? dayjs(this.filters.dataInicio).format('YYYY-MM-DD') : '',
            dataFim: this.filters.dataFim ? dayjs(this.filters.dataFim).format('YYYY-MM-DD') : '',
            beneficiariaId: this.filters.beneficiaria ? this.filters.beneficiaria.id : '',            
            userId: this.user ? this.user.id : '',
            firstName: this.user ? this.user.firstName : '',
            lastName: this.user ? this.user.lastName : ''
        }

        this.aprovacaoMassivaService.aprovar(aprovacaoMassiva).subscribe({
            next: (res: any) => {
                console.log('Aprovação massiva solicitada com sucesso:', res);
                this.progressValue = 100;
                this.snackBar.open('Aprovação massiva para ' + res.totalDios + ' DIOs solicitada com sucesso!', '✕', { panelClass: ['success'] });
            },
            error: (err) => {
                this.progressValue = 100;
                catchErr(err, this.snackBar);
            }
        }).add(() => {
            clearInterval(this.progressInterval);
            setTimeout(() => {
                this.loading = false;
                this.progressValue = 0;
            }, 100);
        });
    }

    private getUsuarios() {
        this.usuario$ = concat(
            of([]), // default items
            this.usuarioInput$.pipe(
                distinctUntilChanged(),
                tap(() => this.loading = true),
                switchMap((term) => {
                    return term ?
                        this.usuarioService.getPaginated<UsuarioResponse>(0, 20, term).pipe(
                                    map((res: Pagination<any>) => res.data),
                                    catchError(() => of([])),
                                    tap(() => this.loading = false)
                                ) : new Promise(() => this.loading = false)
                })
            ) as Observable<UsuarioResponse[]>
        );
    }

}